import { mergeObjectTypes } from '../cacheHelpers';

const LocalDateTimeType = {
  merge: mergeObjectTypes
};

export default LocalDateTimeType;
